/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. You lose water through sweat, so the calculator adds roughly 0.35 litres for every 30 minutes of activity.`)
};

const es_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Pierdes agua a través del sudor, así que la calculadora añade aproximadamente 0,35 litros por cada 30 minutos de actividad.`)
};

const de_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Beim Schwitzen verlierst du Wasser, daher fügt der Rechner pro 30 Minuten Aktivität rund 0,35 Liter hinzu.`)
};

const nl_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Je verliest water door zweten, dus de calculator telt ongeveer 0,35 liter bij op voor elke 30 minuten activiteit.`)
};

const fr_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Vous perdez de l'eau par la transpiration, donc le calculateur ajoute environ 0,35 litre pour chaque tranche de 30 minutes d'activité.`)
};

const it_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Perdi acqua tramite il sudore, quindi il calcolatore aggiunge circa 0,35 litri ogni 30 minuti di attività.`)
};

const pt_br2_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Você perde água pelo suor, então a calculadora acrescenta aproximadamente 0,35 litro a cada 30 minutos de atividade.`)
};

const pt_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Perde água através do suor, por isso a calculadora acrescenta cerca de 0,35 litros por cada 30 minutos de atividade.`)
};

const ja_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。汗で水分が失われるため、この計算機は運動30分ごとに約0.35リットルを加算します。`)
};

const zh_water_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会的。你会通过出汗流失水分，因此计算器会为每 30 分钟运动额外增加约 0.35 升。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_faq_a2", locale)
	if (locale === "en") return en_water_faq_a2(inputs)
	if (locale === "es") return es_water_faq_a2(inputs)
	if (locale === "de") return de_water_faq_a2(inputs)
	if (locale === "nl") return nl_water_faq_a2(inputs)
	if (locale === "fr") return fr_water_faq_a2(inputs)
	if (locale === "it") return it_water_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_water_faq_a2(inputs)
	if (locale === "pt") return pt_water_faq_a2(inputs)
	if (locale === "ja") return ja_water_faq_a2(inputs)
	return zh_water_faq_a2(inputs)
};